import React from 'react'
import { RadioCircle, RadioInner, RadioLabel ,RadioButtonListContainer} from './styled'
import { Text2 } from '../../ui/text'
import theme from '../../../styled/theme'

  const sortOptions = [
    { id: 'fecha', label: 'Fecha' },
    { id: 'clinica', label: 'Clínica' },
    { id: 'numero', label: 'Número de orden' },
  ]
  
export const RadioButton = ({ checked, onChange, label }) => {
  return (
    <RadioLabel onClick={onChange}>
      <Text2 color={theme.colors.text.primaryText}>{label}</Text2>
      <RadioCircle checked={checked}>
        <RadioInner checked={checked} />
      </RadioCircle>
    </RadioLabel>
  )
}

const RadioButtonList = ({
  options = [],
  selected,
  onChange = () => {},
}) => {
  return (
    <RadioButtonListContainer>
      {options.map(option => (
        <RadioButton
          key={option.id}
          checked={selected === option.id}
          onChange={() => onChange(option.id)}
          label={option.label}
        />
      ))}
    </RadioButtonListContainer>
  )
}

export default RadioButtonList
